const currencyFormat = (num) =>
    num ? "$" + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : "$0";

function isValidCUITCUIL(cuit) {
    if (cuit.length != 13) return false;

    let rv = false;
    let resultado = 0;
    let cuit_nro = cuit.replace("-", "");
    const codes = "6789456789";
    let verificador = parseInt(cuit_nro[cuit_nro.length - 1]);
    let x = 0;

    while (x < 10) {
        let digitoValidador = parseInt(codes.substring(x, x + 1));
        if (isNaN(digitoValidador)) digitoValidador = 0;
        let digito = parseInt(cuit_nro.substring(x, x + 1));
        if (isNaN(digito)) digito = 0;
        let digitoValidacion = digitoValidador * digito;
        resultado += digitoValidacion;
        x++;
    }
    resultado = resultado % 11;
    rv = resultado == verificador;
    return rv;
}

const formatCUITCUILWithoutDash = (cuit) => cuit.replaceAll("-", "");

const formatCUITCUILWithDash = (str) =>
    `${str.substring(0, 2)}-${str.substring(2, str.length - 1)}-${str.substring(
        str.length - 1,
        str.length
    )}`;

const fileUrl = (url) => `https://app.copanseguros.com.ar/${url}`;


const isProveedorAutorizado = (value) =>  value === "2"

export {
    currencyFormat,
    isValidCUITCUIL,
    formatCUITCUILWithoutDash,
    formatCUITCUILWithDash,
    fileUrl,
    isProveedorAutorizado,
};
